import { render, staticRenderFns } from "./Firefoo.vue?vue&type=template&id=dc625cb4&"
import script from "./Firefoo.vue?vue&type=script&lang=js&"
export * from "./Firefoo.vue?vue&type=script&lang=js&"
import style0 from "./Firefoo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports